import { css, createGlobalStyle } from 'styled-components';
import { generateCSSVariableStyles } from './BKJThemeProvider.cssVars.js';
import PoppinsSemiBoldWoff2 from '../../assets/fonts/Poppins-SemiBold.woff2?inline';
import PoppinsMediumWoff2 from '../../assets/fonts/Poppins-Medium.woff2?inline';
const cssReset = css `
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  * {
    box-sizing: border-box;
  }

  body {
    ${({ theme }) => theme.fonts.PoppinsTextMedium};
  }
`;
export const CSSReset = createGlobalStyle `${cssReset}`;
const woffFontCSS = css `
  @font-face {
    font-family: 'Poppins SemiBold';
    src: url(${PoppinsSemiBoldWoff2}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'Poppins Medium';
    src: url(${PoppinsMediumWoff2}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
`;
export const CSSFonts = createGlobalStyle `${woffFontCSS}`;
const cssCustomProperties = generateCSSVariableStyles();
export const CSSCustomProperties = createGlobalStyle `${cssCustomProperties}`;
//# sourceMappingURL=BKJThemeProvider.styled.js.map